import { ApproveContext } from './approve-context.model';
import { CloseContext } from './close-context.model';
import { DeleteContext } from './delete-context.model';
import { DisputeContext } from './dispute-context.model';
import { GoalCloseContext } from './goal-close-context.model';
import { NotificationScenario } from './notification-scenario.model';
import { PublishContext } from './publish-context.model';
import { ShareContext } from './share-context.model';

export type NotificationContext =
    | PublishContext
    | CloseContext
    | DeleteContext
    | DisputeContext
    | GoalCloseContext
    | ApproveContext
    | ShareContext;

export class NotificationDispatchDto {
    scenario: NotificationScenario;
    fromUserId: number;
    toUserIds: number[];
    context: NotificationContext;
}
